module.exports = __webpack_public_path__ + "static/media/note.187bce9e.svg";